<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                        <v-form
                                ref="reportIncidentForm"
                        >
                            <h3 class="mb-3">{{$vuetify.lang.t('$vuetify.incident_report.title')}}</h3>
                            <v-textarea
                                    v-model="incident_input"
                                    no-resize
                                    rows="6"
                                    ref="inputRef"
                                    :label="$vuetify.lang.t('$vuetify.incident_report.placeholder')"
                                    autofocus
                                    :disabled="formDisabled"
                            ></v-textarea>
                            <div class="text-center text-md-left">
                            <v-btn class="white--text" color="primary" :disabled="isFilled" @click="doLocationCheck">{{$vuetify.lang.t('$vuetify.global.confirmAndSend')}}</v-btn>
                            </div>
                        </v-form>
            </v-col>
        </v-row>
        <locationPopup :is-visible="showPrivateLocationPopup" @checkComplete="save"></locationPopup>
    </v-container>
</template>

<script>
import PrivateLocationCheckComponent from '../global/privateLocationChecker/PrivateLocationCheckComponent';
import urlParamsConstructor from '../../../mixins/config/urlParamsConstructor';
import {ENTRY_DATA_KEY, LMRADataObjectHelper} from "@/api/repository/helpers/LMRADataObjectHelper";
import lmraDataRepositoryApi from "@/api/repository/lmraDataRepositoryApi";
import sendingLmraDataHelper from "@/helpers/sendingLmraDataHelper";

export default {
    name: "ReportIncidentComponent",
    data : () => {
            return {
                formDisabled : false,
                incident_input : '',
                minLength : 4,
                showPrivateLocationPopup : false,
            }
        },
        components :{
            locationPopup : PrivateLocationCheckComponent
        },
        methods : {
            doLocationCheck(){
                this.showPrivateLocationPopup = true;
            },
            async save(){
                this.formDisabled = true;
                this.showPrivateLocationPopup = false;
                let dataObject  = await LMRADataObjectHelper.buildBaseLmraDataObject();
                dataObject[ENTRY_DATA_KEY]['description'] = this.incident_input.trim();

                window.console.log(dataObject);

                //START SENDING PART
                await lmraDataRepositoryApi.reportIncident(dataObject).then(
                    response => {
                      window.console.log('RESPONSE : ')
                      window.console.log(response);
                      let message = this.$vuetify.lang.t('$vuetify.global.post_success');
                      if(response.data.message !== undefined){
                        message = response.data.message;
                      }
                      sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(message)
                      this.$router.replace('/');
                    }
                ).catch(error =>{
                  window.console.log('ERROR');
                  window.console.log(error);
                  sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(this.$vuetify.lang.t('$vuetify.errors.data_save_failed') + ' err: ' + error.message);
                  this.formDisabled = false;
                });
            }
        },
    mixins:[urlParamsConstructor],
    computed : {
          isFilled : function () {
              let trimmed = this.incident_input.trim()
              if(trimmed.length >= this.minLength && !this.formDisabled){
                  return false;
              }else{
                  return true
              }
          }
        }
}
</script>